import React from 'react';
import { Lightbulb, Warning, Info } from '@phosphor-icons/react';
import classNames from 'classnames';
import parse from 'html-react-parser';

interface Props {
  variant?: 'grey' | 'red' | 'green';
  alertData?: {
    variant?: 'tip' | 'warning' | 'info';
    text: string | React.ReactNode;
  };
  generatedAlertText?: string;
  noIcon?: boolean;
  addClass?: string;
}

const Alert: React.FC<Props> = (props) => {
  const { variant, alertData, generatedAlertText, noIcon, addClass } = props;

  const iconClass = classNames({
    'text-black': !variant || variant === 'grey',
    'text-error-900': variant === 'red',
    'text-success-900': variant === 'green',
  });

  const Icon = (() => {
    switch (alertData?.variant) {
      case 'tip':
        return Lightbulb;
      case 'warning':
        return Warning;
      case 'info':
      default:
        return Info;
    }
  })();

  return (
    <div
      className={classNames(
        'w-full flex flex-col p-3 sm:p-4 gap-4 rounded-md border border-solid',
        {
          'bg-grey-100 border-transparent': !variant || variant === 'grey',
          'bg-error-translucent border-error-900': variant === 'red',
          'bg-success-translucent border-success-900': variant === 'green',
        },
        addClass,
      )}
    >
      {generatedAlertText && (
        <div className="flex flex-row gap-2 sm:gap-4">
          <Warning weight="fill" size="1.5rem" className={iconClass} />
          <div className="w-[calc(100%_-_2rem)] sm:w-[calc(100%_-_2.5rem)]">
            <b>Videos have already been generated.</b> {generatedAlertText}
          </div>
        </div>
      )}

      {alertData && (
        <div className="flex flex-row gap-2 sm:gap-4">
          {!noIcon && (
            <Icon weight="fill" size="1.5rem" className={iconClass} />
          )}

          <div
            className={classNames(
              noIcon
                ? 'w-full'
                : 'w-[calc(100%_-_2rem)] sm:w-[calc(100%_-_2.5rem)]',
            )}
          >
            {typeof alertData.text === 'string'
              ? parse(alertData.text)
              : alertData.text}
          </div>
        </div>
      )}
    </div>
  );
};

export default Alert;
